import { TYPES, ErrorMessages } from '../../common/constants';
import * as client from '../../services/client';
import { startFormLoading, stopFormLoading } from './loader';
import { toast } from 'react-toastify';
import { ToastFail } from '../../helpers/validationHelper';
import { startInboxLoader, stopInboxLoader } from './Inbox';


export const fetchMessages = data => dispatch =>{
  dispatch(startFormLoading())
    return client.fetchMessages(data).then(
      response => {
        if(response.status === 200 || response.ok){
          response.json().then(
            responsejson => {
              dispatch(fetchMessagesDone(responsejson)); 
              dispatch(stopFormLoading())
            }
          )

        }else{
          dispatch(stopFormLoading())
          // alert('Fetching Messages Failed !')
        }
      }
    )
  }

  const fetchMessagesDone = payload => ({
    type: TYPES.FETCH_MESSAGES_DONE,
    payload,
  });


  const postMessageDone = payload => ({
    type:TYPES.POST_MESSAGE_DONE,
    payload,
  })

  export const clearMessages = () => ({
    type: TYPES.CLEAR_MESSAGES
  })

  export const postMessage = data => dispatch => {
    // dispatch(startFormLoading())
    return client.postMessage(data).then(response => {
      // dispatch(stopFormLoading())
      if(response.status === 200 || response.ok){
        response.json().then(responsejson => {
          if(responsejson && responsejson.statusCode === 200) {
            if(responsejson.messages && responsejson.messages.id){
              dispatch( postMessageDone(responsejson.messages))
            } else {
              toast.error('🚫 Message sending failed.',{autoClose:3000,position:'top-center'})
            }
          } else {
            toast.error('🚫 Message sending failed.',{autoClose:3000,position:'top-center'})
          }
        })
      } else {
        toast.error('🚫 Something went wrong with sending message, Please try again.',{autoClose:3000,position:'top-center'})
      }
    }).catch(() => {
      toast.error('🚫 Something went wrong with sending message, Please try again.',{autoClose:3000,position:'top-center'})
    })
  }

  export const sendEmailNotification = (data, url, history) => dispatch => {
    dispatch(startInboxLoader());
    return client.sendEmailNotification(data).then(response => {
      dispatch(stopInboxLoader());
      if(response.status === 200){
        response.json().then(responsejson => {
          if(responsejson.statusCode === 200) {
             history.push(url);
          } else {
            ToastFail(ErrorMessages.sendEmailFailed);
          }          
        })
      }
    }).catch(() => {
      dispatch(stopInboxLoader());
      ToastFail(ErrorMessages.sendEmailFailed);
    })
  }

  export const fetchLatestMessages = data => dispatch =>{
    return client.fetchLatestMessages(data).then(
      response => {
        if(response.status === 200 || response.ok){
          response.json().then(
            responsejson => dispatch(fetchMessagesDone(responsejson))
          )

        }else{
          // alert('Fetching Messages Failed !')
        }
      }
    )
  }
  export const deleteMessage = data => dispatch => {
    dispatch(fetchMessagesDone(data))
  }